import common, { loadCommonSensitiveData } from './common'
import formLabels from './formLabels'
import devOpts from './dev'
import productOpts from './product'
import contractNodes from './contractNodes'

const opts = __DEV__ ? devOpts : productOpts

const config = {}

const assignConfig = () => {
  Object.assign(config, common, formLabels, contractNodes, opts)
}

assignConfig()

export const loadSensitiveConfig = async () => {
  await loadCommonSensitiveData()
  assignConfig()
}

export default config
